<template>
  <div class="add">
    <div style="max-height: 70vh; overflow-y: auto;padding: 10px 15px;">
      <el-form
        ref="ruleForm"
        :model="ruleForm"
        :rules="rules"
        size="small"
        label-position="top"
      >
        <el-row :gutter="10">
          <el-col :span="8">
            <el-form-item :label="$t('routes.班次编号')" prop="scheduleNumber">
              <el-input
                v-model="ruleForm.scheduleNumber"
                maxlength="100"
                show-word-limit
                :placeholder="$t('GlobalSetObj.pleaseInput')"
                :disabled="classId !== '' && classId !== null && classId !== undefined"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              :label="$t('GlobalSetObj.client') + '：'"
              prop="customerIdList"
              :rules="{
                required: true,
                message: $t('GlobalSetObj.pleaseChoose'),
                trigger: ['blur', 'change']
              }"
            >
              <el-select
                v-model="ruleForm.customerIdList"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                filterable
                clearable
                class="select"
                remote
                :disabled="classId !== '' && classId !== null && classId !== undefined"
                :remote-method="asyncCustomerList"
                style="width: 100%;"
                @visible-change="asyncCustomerList()"
              >
                <el-option
                  v-for="item of customerList"
                  :key="item.id"
                  :label="item.customerAlias + (item.username ? '（' + item.username + '）' : '')"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <!--转运中心-->
            <el-form-item
              :label="$t('collectionCenter.transferCenter')"
              prop="transferCenterId"
              :rules="{
                required: true,
                message: $t('GlobalSetObj.pleaseChoose'),
                trigger: ['blur', 'change']
              }"
            >
              <el-select
                v-model="ruleForm.transferCenterId"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                clearable
                filterable
                style="width: 100%"
                :disabled="classId !== '' && classId !== null && classId !== undefined"
              >
                <el-option
                  v-for="item in transferList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <template>
          <el-card v-for="(item, ind) in ruleForm.collectTimeList" :key="ind">
            <el-row :gutter="10">
              <el-col :span="10">
                <!--揽收时间-->
                <el-form-item
                  :label="$t('collectionCenter.lanshouT')"
                  :prop="`collectTimeList.${ind}.startCollectTime`"
                  :rules="{
                    required: true,
                    validator:(rule, value, callback)=>collectTimeCheck(rule, value, callback, item, ruleForm.collectTimeList, 1),
                    trigger: ['blur', 'change']
                  }"
                  style="display: inline-block"
                >
                  <el-time-picker
                    v-model="item.startCollectTime"
                    :placeholder="$t('GlobalSetObj.pleaseChoose')"
                    format="HH:mm"
                    value-format="HH:mm"
                    style="width: 180px;"
                  />
                </el-form-item>
                <span style="margin: 0 5px;">~</span>
                <el-form-item
                  :prop="`collectTimeList.${ind}.endCollectTime`"
                  :rules="{
                    required: true,
                    validator:(rule, value, callback)=>collectTimeCheck(rule, value, callback, item, ruleForm.collectTimeList, 2),
                    trigger: ['blur', 'change']
                  }"
                  style="display: inline-block"
                >
                  <el-time-picker
                    v-model="item.endCollectTime"
                    :placeholder="$t('GlobalSetObj.pleaseChoose')"
                    format="HH:mm"
                    value-format="HH:mm"
                    style="width: 180px;"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!--揽收装车时间-->
                <el-form-item
                  :label="$t('GlobalSetObj.collectuploadTime')"
                  :prop="`collectTimeList.${ind}.collectLoadFinishTime`"
                  :rules="{
                    required: true,
                    validator:(rule, value, callback)=>collectLoadFinishTimeCheck(rule, value, callback, item),
                    trigger: ['blur', 'change']
                  }"
                >
                  <el-time-picker
                    v-model="item.collectLoadFinishTime"
                    :placeholder="$t('GlobalSetObj.pleaseChoose')"
                    format="HH:mm"
                    value-format="HH:mm"
                    style="width: 100%;"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!--到达HUB时间-->
                <el-form-item
                  :label="$t('collectionCenter.ArrivalTimeAtHUB')"
                  :prop="`collectTimeList.${ind}.hub1ArrivalTime`"
                  :rules="{
                    required: true,
                    validator:(rule, value, callback)=>hub1ArrivalTimeCheck(rule, value, callback, item),
                    trigger: ['blur', 'change']
                  }"
                >
                  <el-time-picker
                    v-model="item.hub1ArrivalTime"
                    :placeholder="$t('GlobalSetObj.pleaseChoose')"
                    format="HH:mm"
                    value-format="HH:mm"
                    style="width: 100%;"
                  />
                </el-form-item>
              </el-col>
              <el-col v-if="ind !== 0" :span="2" style="text-align: right">
                <el-popconfirm
                  :title="$t('GlobalSetObj.AreYouSureDelete')"
                  @confirm="delRow(ind)"
                >
                  <el-button slot="reference" type="text" size="small">
                    <i class="el-icon-close" style="font-size: 25px; color: #DD4A68" />
                  </el-button>
                </el-popconfirm>
              </el-col>
            </el-row>
          </el-card>
        </template>
      </el-form>
    </div>
    <div style="padding: 10px; text-align: right">
      <el-button
        style="float: left"
        type="primary"
        plain
        size="small"
        @click="addRow"
      >{{ $t('collectionCenter.AddCollectionTime') }}</el-button><!--添加揽收时间-->
      <el-button type="primary" size="small" @click="submitForm('ruleForm')">{{ $t('customerManagements.Save') }}</el-button>
      <el-button size="small" @click="onClose(false)">{{ $t('GlobalSetObj.cancel') }}</el-button>
    </div>
  </div>
</template>

<script>
// import AddTimeCmp from './AddTimeCmp.vue';
import { apiDepartureScheduleModify } from '@/api/routerPlan.js';
import { cloneDeep } from 'lodash-es';
import {
  collectTimeCheck,
  collectLoadFinishTimeCheck,
  hub1ArrivalTimeCheck,
  SCHEDULE_ROW
} from './../utils';
import { apiCustomerPage } from '@/api/customer';

/** @typedef {import('../types').TCollectTime} TCollectTime */

export default {
  name: '',

  components: {
    // AddTimeCmp
  },

  props: {
    index: {
      type: Number,
      default: 0
    },

    // 当前行的数据
    row: {
      type: Object,
      default: () => {
        return cloneDeep(SCHEDULE_ROW);
      }
    },
    transferList: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },

  data() {
    return {
      ruleForm: {
        scheduleNumber: '',
        transferCenterId: '',
        collectTimeList: [],
        customerIdList: ''
      },
      rules: {
        scheduleNumber: [
          { required: true, message: this.$t('GlobalSetObj.pleaseInput'), trigger: 'blur' }
        ]
      },
      classId: null,
      customerList: [],
      collectTimeCheck,
      collectLoadFinishTimeCheck,
      hub1ArrivalTimeCheck
    };
  },

  watch: {
    index: {
      handler(val) {
        const { id } = this.row.row;
        this.classId = id;
        let arr = [{
          startCollectTime: '00:00',
          endCollectTime: '01:00',
          collectLoadFinishTime: '', // 揽收装车完成时间
          hub1ArrivalTime: '' // HUB1到件时间
        }];
        // 编辑
        if (id) {
          const { collectTimeList } = this.row.row;
          this.ruleForm.scheduleNumber = this.row.scheduleNumber;
          this.ruleForm.customerIdList = Number(this.row.customerIdList);
          this.ruleForm.transferCenterId = this.row.transferCenterId;
          this.customerList = [
            {
              id: this.ruleForm.customerIdList,
              customerAlias: this.row.customerNameList
            }
          ];
          arr = collectTimeList.map(item => {
            const { collectTime, collectLoadFinishTime, hub1ArrivalTime } = item;
            return {
              startCollectTime: collectTime[0],
              endCollectTime: collectTime[1],
              collectLoadFinishTime,
              hub1ArrivalTime
            };
          });
        } else {
          // 新增
          this.ruleForm.scheduleNumber = '';
          this.ruleForm.transferCenterId = '';
          this.ruleForm.customerIdList = '';
        }
        this.ruleForm.collectTimeList = arr;
      },
      immediate: true
    }
  },

  created() {

  },

  methods: {
    // 获取客户列表
    asyncCustomerList(name = '') {
      const obj = {
        pageSize: 20,
        pageNumber: 1,
        params: {
          quickSearch: name
        }
      };
      apiCustomerPage(obj, false).then(res => {
        if (res.code !== 200) { return; }
        this.customerList = res.data.records.map(item => {
          return {
            id: item.id,
            customerAlias: item.customerAlias,
            username: item.username
          };
        });
      });
    },
    // 新增
    addRow() {
      const COLLECT_TIME_ROW = {
        startCollectTime: '00:00',
        endCollectTime: '01:00',
        collectLoadFinishTime: '', // 揽收装车完成时间
        hub1ArrivalTime: '' // HUB1到件时间
      };
      this.ruleForm.collectTimeList.push(COLLECT_TIME_ROW);
    },
    // 删除
    delRow(index) {
      this.ruleForm.collectTimeList.splice(index, 1);
    },
    getData() {
      const { id } = this.row.row;
      const { scheduleNumber, customerIdList, collectTimeList, transferCenterId } = this.ruleForm;

      const obj = {
        id: id || null,
        scheduleNumber,
        customerIdList,
        collectTimeList,
        transferCenterId
      };

      return obj;
    },

    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) {
          return;
        }
        if (this.ruleForm.collectTimeList !== null) {
          // 新增 / 编辑
          this.asyncApiDepartureScheduleModify();
        }
      });
    },

    // 新增编辑
    asyncApiDepartureScheduleModify() {
      const obj = this.getData();
      apiDepartureScheduleModify(obj).then(res => {
        this.$message.success(this.$t('GlobalSetObj.SaveSuccessfully'));

        setTimeout(() => {
          this.onClose(true);
        }, 1000);
      }).catch(err => {
        console.error(err);
      });
    },

    onClose(isBool) {
      this.$emit('close', isBool);
    }
  }

};
</script>

<style scoped>
.add {
  margin: -10px -15px;
}
</style>
